<div class="customer_delete" id="actionsID">
<mat-dialog-content>
    <div 
    style="text-align: center;">
    <img 
      src="assets/img/home/Rejected.png" 
      alt="rejected-logo" 
      style="font-size: 7rem; width: 150px !important;">
  </div>
  <br/>
    <div class="text-center">
       
        <p>
            {{ titleMsgs}}
            <br/>
            <span class="highlight-text">
              {{ titleMsg }}
            </span>
          </p>

    </div>
</mat-dialog-content>
<mat-dialog-actions class="d-flex flex-column align-items-center">
    <button class="btn btn-p-2 p-3 w-100 h5 shadow-sm rounded-pill mb-3"
        (click)="onConfirmClick()" tabindex="1">{{"COMMON.YES" | translate}}</button>
    <button class="btn btn-cancel p-3 w-100 h5 shadow-sm rounded-pill"
        mat-dialog-close
        tabindex="-1">{{"COMMON.Cancel" | translate}}</button>
</mat-dialog-actions>
</div>